import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  NullableBooleanInput,
  SaveButton,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { useNotifyError } from "utils/useNotifyError";

const AddDocumentTypeForm = ({ campaign, onDone }) => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSave = async data => {
    try {
      await dataProvider.customRequest(
        doctoralRequests.addCampaignDocumentType(campaign.id),
        { nameBg: data.nameBg, nameEn: data.nameEn, isRequired: data.isRequired },
        "POST",
      );
      notify("Документът е добавен успешно", { type: "success" });
      refresh();
      onDone();
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <SimpleForm
      toolbar={false}
      onSubmit={handleSave}
      record={{}}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="nameBg"
            label="Наименование на български"
            fullWidth
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="nameEn"
            label="Наименование на английски"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <NullableBooleanInput
            label="Задължително"
            source="isRequired"
            nullLabel=""
            falseLabel="Не"
            trueLabel="Да"
            fullWidth
            validate={required()}
          />
        </Grid>
      </Grid>
      <Grid sx={{ display: "flex", gap: 3, mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          size="small"
          label="Откажи"
          onClick={onDone}
        />
        <SaveButton
          label="Запази"
          size="small"
          alwaysEnable
        />
      </Grid>
    </SimpleForm>
  );
};

export default AddDocumentTypeForm;
